import { graphql, useLazyLoadQuery } from 'react-relay';
import {
  FilteredSurveyInput,
  useEarnQuery as useEarnQueryType,
} from './__generated__/useEarnQuery.graphql';

const earnQuery = graphql`
  query useEarnQuery($input: FilteredSurveyInput!) {
    walletBalance {
      ...RedeemBanner_balance
    }
    targetRedemptionValue {
      ...RedeemBanner_target
    }
    surveys(input: $input) {
      pageInfo {
        totalCount
      }
    }
    ...useSurveyListFragmentQuery_surveysRef @arguments(input: $input)
    ...useMoreSurveysBannerQuery_profileUrlRef
    consentSettings {
      ...TermsAndConditionsConsent_consentSettings
    }
    ...useNoSurveysFragmentQuery_noSurveysRef
    profilerUrl
    signupSurveyUrl
    notificationSubscriptions {
      surveyInviteContactChannels
    }
    userData {
      firstName
    }
  }
`;

export function useEarnQuery(variables: { input: FilteredSurveyInput }) {
  return useLazyLoadQuery<useEarnQueryType>(earnQuery, variables, {
    fetchPolicy: 'store-or-network',
  });
}
